<template>
    <div class="content">
        <div v-if="!showExcel">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <a data-toggle="collapse" href="#importFile" role="button" aria-expanded="false" aria-controls="filter">
                {{ $t('import.file') }}
              </a>
              |
              <a data-toggle="collapse" href="#filter" role="button" aria-expanded="false" aria-controls="filter">
                {{ $t('app.filter') }}
              </a>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="datatable_filter float-right">
                <div class="row">
                  <div class="col">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="showNextContactToday"
                        v-model="filter.archive"
                        @change="fetchImports"
                        true-value="1"
                        false-value="0"
                      >
                      <label class="form-check-label" for="showNextContactToday">{{ $t('app.show_archive') }}</label>
                    </div>
                  </div>
                  <div class="col">
                    <label>
                      <select v-model="tableData.length" @change="fetchImports()" class="form-control form-control-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="collapse" id="importFile">
            <div class="block block-rounded block-bordered" v-if="permissions.indexOf('import-file') != -1">
              <div class="block-header block-header-default">
                <h3 class="block-title">{{ $t('import.file') }}</h3>

                <div class="block-options">
                  <a :href="`${getAppUrl()}/excel/import.xlsx`">{{ $t('import.download_template') }}</a>
                </div>
              </div>
              <div class="block-content">
                <form @submit.stop.prevent="fileInputSubmit">
                    <div class="form-group">
                      <label for="inlineFormCustomSelect">{{ $t('app.action') }}</label>
                      <select class="form-control" id="inlineFormCustomSelect" v-model="action" :class="{'is-invalid': errors.action }">
                          <option selected value="">{{ $t('placeholder.select') }}</option>
                          <option value="import_debtors">{{ $t('import.import_debtors') }}</option>
                          <option value="update_debts">{{ $t('import.update_debts') }}</option>
                          <option value="distribution_debts">{{ $t('import.distribution_debts') }}</option>
                          <option value="delete_debts">{{ $t('import.delete_debts') }}</option>
                          <option value="add_payments">{{ $t('import.add_payments') }}</option>
                          <option value="add_additional_data">{{ $t('import.add_additional_data') }}</option>
                      </select>
                      <span v-if="errors.action" class="invalid-feedback">
                          <strong>{{ errors.action ? errors.action[0] : '' }}</strong>
                      </span>
                    </div>
                    <div class="form-group">
                      <input
                        type="file"
                        class="form-control-file"
                        name="file"
                        ref="files"
                        @change="fileInputChange"
                        :class="{'is-invalid': errors.file }"
                      >
                      <span v-if="errors.file" class="invalid-feedback">
                          <strong>{{ errors.file ? errors.file[0] : '' }}</strong>
                      </span>
                    </div>

                    <div class="form-group">
                      <div class="progress mb-2" style="height: 30px" v-if="fileProgress ">
                        <div
                          class="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          :style="{width: fileProgress + '%' }"
                          :aria-valuenow="fileProgress"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {{fileCurrent}}
                        </div>
                      </div>
                      <button type="submit" class="btn btn-primary" name="button" :disabled="isProcessing" >
                          <i class="fa fa-spinner fa-pulse fa-fw" v-if="isProcessing"></i> {{ $t('import.upload') }}
                      </button>
                    </div>
                </form>
              </div>
            </div>
          </div>

          <div class="collapse" id="filter">
            <div class="block block-rounded block-fx-shadow">
                <div class="block-content block-content-full">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                          <label for="importtype" class="col-form-label">{{ $t('import.type') }}</label>
                          <select class="form-control form-control-sm" id="importtype" v-model="filter.type">
                            <option selected value="">{{ $t('field.any') }}</option>
                            <option value="import_debtors">{{ $t('import.import_debtors') }}</option>
                            <option value="update_debts">{{ $t('import.update_debts') }}</option>
                            <option value="distribution_debts">{{ $t('import.distribution_debts') }}</option>
                            <option value="delete_debts">{{ $t('import.delete_debts') }}</option>
                            <option value="add_payments">{{ $t('import.add_payments') }}</option>
                            <option value="add_additional_data">{{ $t('import.add_additional_data') }}</option>
                          </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                          <label for="importtype" class="col-form-label">{{ $t('import.status') }}</label>
                          <select class="form-control form-control-sm" id="importtype" v-model="filter.status">
                            <option selected value="">{{ $t('field.any') }}</option>
                            <option value="started">{{ $t('import.status_start') }}</option>
                            <option value="done">{{ $t('import.status_done') }}</option>
                            <option value="failed">{{ $t('import.status_failed') }}</option>
                          </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                          <label class="col-form-label">{{ $t('field.user') }}</label>
                          <select class="form-control form-control-sm" v-model="filter.user_id">
                            <option selected="true" value="">{{ $t('field.any') }}</option>
                            <option v-for="user in adminListUsers" :value="user.id" :key="user.id">
                              {{ user.fullname }}
                            </option>
                          </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('import.created_at') }}</label>
                        <div class="input-group input-group-sm">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="datestart">C</span>
                          </div>
                          <input type="datetime-local" class="form-control" aria-label="Small" v-model="filter.period_imported_start_date" aria-describedby="datestart" />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('import.created_at') }}</label>
                        <div class="input-group input-group-sm">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="dateend">По</span>
                          </div>
                          <input type="datetime-local" class="form-control" aria-label="Small" v-model="filter.period_imported_end_date" aria-describedby="dateend" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="text-center">
                        <div class="btn-group" role="group" aria-label="btnGroup1">
                          <button class="btn btn-primary" @click="filterImports()">
                            <font-awesome-icon icon="search" /> {{ $t('field.find') }}
                          </button>
                          <button class="btn btn-danger" @click="resetForm()">
                            <font-awesome-icon icon="times" /> {{ $t('field.reset') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div class="block block-rounded block-fx-shadow">
              <div class="block-header">
                <h3 class="block-title">{{ $t('import.list') }}</h3>
                <div class="block-options">
                  <router-link :to="{ name: 'adminOldImport' }">
                    Посмотреть старые отчеты
                  </router-link>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover table-bordered bg-white table-striped">
                    <thead>
                        <th>#</th>
                        <th>{{ $t('app.action') }}</th>
                        <th>{{ $t('import.filename') }}</th>
                        <th>{{ $t('import.user') }}</th>
                        <th class="text-center">{{ $t('import.status') }}</th>
                        <th>{{ $t('import.type') }}</th>
                        <th>{{ $t('import.count') }}</th>
                        <th>{{ $t('import.errors') }}</th>
                        <th>{{ $t('import.created_at') }}</th>
                    </thead>
                    <tbody>
                      <template v-if="!loadExcels">
                        <tr v-for="(excel, index) in excels" :key="excel.id">
                          <td>{{index+1}}</td>
                          <td>
                            <div class="btn-group">
                              <router-link v-if="!excel.deleted_at" :to="{ name: 'adminImportReport', params: { id: excel.id } }" class="btn btn-info btn-sm" title="Посмотреть отчет">
                                <i class="fa fa-eye"></i>
                              </router-link>
                              <button
                                @click.prevent="handleDelete(excel.id)"
                                class="btn btn-danger btn-sm "
                                v-if="!excel.deleted_at"
                                :disabled="isProcessing"
                                title="Удалить"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                              <button
                                @click.prevent="restoreExcel(excel.id)"
                                class="btn btn-success btn-sm "
                                v-if="excel.deleted_at"
                                :disabled="isProcessing"
                                title="Восстановить"
                              >
                                {{ $t('buttons.restore') }}
                              </button>
                              <button
                                @click.prevent="handleForceDelete(excel.id)"
                                class="btn btn-danger btn-sm "
                                v-if="excel.deleted_at"
                                :disabled="isProcessing"
                                title="Окончательно удалить"
                              >
                                <i class="fa fa-trash-o"></i>
                              </button>
                            </div>
                          </td>
                          <td>{{excel.original_filename}}</td>
                          <td>{{excel.user ? `${excel.user.fullname}`: '' }}</td>
                          <td class="text-center">
                            <i class="fa fa-pause-circle-o text-warning fa-2x" v-if="excel.status == 'started'" :title="`Задание началось ${excel.created_at}`"></i>
                            <i class="fa fa-check text-success fa-2x" v-if="excel.status == 'done'" title="Задание завершено успешно"></i>
                            <i class="fa fa-times text-danger fa-2x" v-if="excel.status == 'failed'" title="Задание завершено с ошибками"></i>
                          </td>
                          <td>
                            <span>{{ $t('import.' + excel.type) }}</span>
                          </td>
                          <td>
                            <span>{{ $t('import.all') }}: <strong>{{ excel.count ? excel.count.all: 0 }}</strong><br></span>
                            <span v-if="excel.type !== 'add_payments'" class="text-success">
                              {{ $t('import.success_import') }}:
                              <strong v-if="excel.type == 'import_debtors' && excel.count">
                                {{ excel.count ? excel.count.debts: 0 }}
                              </strong>
                              <strong v-if="excel.type != 'import_debtors'">
                                {{excel.successfully_imported_debts_count}}
                              </strong>
                              <br>
                            </span>

                            <span v-if="excel.type === 'add_payments'" class="text-success">
                              {{ $t('import.success_import') }}: <strong>{{excel.successfully_imported_payments_count}}</strong><br>
                            </span>
                            <span v-if="excel.type === 'import_debtors'" class="text-info">
                              {{ $t('import.successfully_imported_debtors_count', { count: excel.successfully_imported_debtors_count }) }}<br>
                            </span>

                            <span v-if="excel.type == 'import_debtors'" class="text-danger">
                              {{ $t('import.failed_import') }}: <strong>{{excel.failed_imported_debtors_count}}</strong><br>
                            </span>
                            <span v-if="excel.type != 'import_debtors' && excel.type != 'add_payments'" class="text-danger">
                              {{ $t('import.failed_import') }}: <strong>{{excel.failed_imported_debts_count}}</strong><br>
                            </span>
                            <span v-if="excel.type == 'add_payments'" class="text-danger">
                              {{ $t('import.failed_import') }}: <strong>{{excel.failed_imported_payments_count}}</strong><br>
                            </span>
                          </td>
                          <td>{{excel.errors}}</td>
                          <td>{{excel.created_at| datetimeFormat }}</td>
                        </tr>
                      </template>
                      <tr v-if="loadExcels">
                        <td colspan="11" class="text-center">
                          <loader-wave/>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
          </div>
          <pagination :pagination="pagination" :offset="4" @paginate="fetchImports()"/>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      excels: [],
      action: '',
      files: [],
      fileProgress: 0,
      fileCurrent: '',
      errors: {},
      loadExcels: false,
      isProcessing: false,
      showExcel: false,
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'asc',
      },
      filter: {
        archive: 0,
        type: '',
        status: '',
        user_id: '',
        period_imported_start_date: '',
        period_imported_end_date: '',
      },
      pagination: {
        current_page: 1,
      },
    };
  },
  computed: {
    ...mapGetters([
      'adminListUsers',
      'permissions',
    ]),
  },
  mounted() {
    this.fetchImports();
    this.GET_ADMIN_LIST_USERS();
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_USERS',
    ]),

    fetchImports() {
      this.loadExcels = true;
      this.tableData.draw += 1;

      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`/admin/imports/excels?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.excels = res.data.excels.data;
            this.pagination = this.laraPaginate(res.data.excels);
          } else {
            console.log('failed');
          }
          this.loadExcels = false;
        });
    },

    filterImports() {
      this.pagination.current_page = 1;
      this.fetchImports();
    },

    resetForm() {
      this.filter = {
        archive: 0,
        type: '',
        status: '',
        user_id: '',
      };
      this.fetchImports();
    },

    clearFileInput() {
      this.errors = {};
      this.files = [];
      this.action = '';
      this.fileProgress = 0;
      this.fileCurrent = '';
      this.$refs.files.value = '';
    },

    async fileInputChange() {
      this.files = [];
      this.fileProgress = 0;
      this.fileCurrent = '';

      const items = Array.from(event.target.files);
      for (const item of items) {
        this.files.push(item);
      }
    },

    async fileInputSubmit(evt) {
      evt.preventDefault();
      for (const item of this.files) {
        await this.uploadFile(item);
      }
    },

    async uploadFile(item) {
      const form = new FormData();
      form.append('file', item);
      form.append('action', this.action);
      this.isProcessing = true;
      await window.axios.post('/admin/imports/file', form, {
        onUploadProgress: (itemUpload) => {
          this.fileProgress = Math.round((itemUpload.loaded / itemUpload.total) * 100);
          this.fileCurrent = `${item.name} ${this.fileProgress}%`;
        },
      }).then((res) => {
        if (res.data.success) {
          window.Swal.fire(this.$t('alerts.success'), 'Файл успешно загружен в сервер', 'success');
          this.clearFileInput();
          this.fetchImports();
        }
      }).catch((err) => {
        this.errors = this.laravelValidation(err);
      }).finally(() => {
        this.isProcessing = false;
      });
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.deleteExcel(id);
        }
      });
    },

    handleForceDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: 'Вы действительно хотите удалить данные без возможности восстановления',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.forceDeleteExcel(id);
        }
      });
    },

    deleteExcel(id) {
      window.axios.delete(`/admin/imports/excels/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchImports();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    restoreExcel(id) {
      window.axios.put(`/admin/imports/excels/${id}/restore`)
        .then((res) => {
          if (res.status === 202) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchImports();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    forceDeleteExcel(id) {
      window.axios.delete(`/admin/imports/excels/${id}/forcedelete`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchImports();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
